import AddAccont24 from "@/assets/SVG/addAccont24";
import FlagIcon24 from "@/assets/SVG/flagIcon24";
import ReportIcon24 from "@/assets/SVG/reportIcon24";
import { Grid, Typography } from "@mui/material";
import DashboardIcon from "../../assets/SVG/dashboard";
import DrugIcon from "../../assets/SVG/drugIcon";
import UserCheckIcon from "../../assets/SVG/userCheckIcon";
import { OptionsSidebar } from "./sidebar";
import NoteIcon24 from "@/assets/SVG/noteIcon24";
import { ProfileIcon } from "@/assets";
import ProfileIcon24 from "@/assets/SVG/profileIcon24";

export default function SidebarGroup() {
  return (
    <Grid display={"flex"} flexDirection={"column"} gap={"10px"} mt={"50px"}>
      <Typography color={"text.primary"}>ابزار</Typography>
      <Grid display={"flex"} flexDirection={"column"} gap={"10px"} mr={"10px"}>
        <OptionsSidebar
          href="/"
          select={window.location.pathname === "/"}
          text="داشبورد"
          icon={<DashboardIcon color={"white"} />}
        />
        <OptionsSidebar
          href="/notes"
          select={window.location.pathname === "/notes"}
          text="یادداشت‌ها"
          icon={<NoteIcon24 width={24} color={"white"} />}
        />
        <OptionsSidebar
          href="/trips"
          select={window.location.pathname === "/trips"}
          text="اردو ها"
          icon={<FlagIcon24 color={"white"} />}
        />
        <OptionsSidebar
          href="/users_trip"
          select={window.location.pathname === "/users_trip"}
          text="ثبت‌نام کنندگان"
          icon={<AddAccont24 color={"white"} />}
        />
        <OptionsSidebar
          href="/reports"
          select={window.location.pathname === "/reports"}
          text="گزارشات"
          icon={<ReportIcon24 color={"white"} />}
        />
        <OptionsSidebar
          href="/drug"
          select={window.location.pathname === "/drug"}
          text="داروخانه"
          icon={<DrugIcon color={"white"} />}
        />
        <OptionsSidebar
          href="/equipment"
          select={window.location.pathname === "/equipment"}
          text="تجهیزات"
          icon={<DrugIcon color={"white"} />}
        />
        <OptionsSidebar
          href="/erja"
          select={window.location.pathname === "/erja"}
          text="ارجاعات"
          icon={<UserCheckIcon color={"white"} />}
        />
        <OptionsSidebar
          href="/accesses"
          select={window.location.pathname === "/accesses"}
          text="دسترسی"
          icon={<ProfileIcon24 color={"white"} />}
        />
      </Grid>
    </Grid>
  );
}
